<template>
  <vx-card card-border no-shadow :title="$t('request_forms.select_address')" id="select-address">
    <div class="vx-row">
      <div
        class="vx-col p-3 w-full md:w-1/2"
        :key="index"
        v-for="(address, index) in $store.state.AppActiveUser.addresses"
      >
        <vx-card
          card-border
          no-shadow
          :class="index === selectedAddressIndex ? 'bg-success-gradient text-white opacity-75' : ''"
        >
          <address-string :address="address" hide-label class="text-xl" />
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                v-if="index !== selectedAddressIndex"
                icon-pack="feather"
                icon="icon-check"
                type="border"
                color="success"
                size="small"
                @click="selectedAddressIndex = index"
              >
                {{ $t('button.select') }}
              </vs-button>
              <div v-else style="height: 2.2em"></div>
            </vs-row>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- Add new Address Form -->
    <vs-button
      v-if="!showAddAddress"
      class="w-full"
      color="success"
      type="border"
      icon-pack="feather"
      icon="icon-plus"
      @click="showAddAddress = true"
    >
      {{ $t('forms.add') }} {{ $t('users.address') }}
    </vs-button>
    <template v-if="showAddAddress">
      <open-street-map :clear-selection="clearMapMarker" class="m-3" v-model="mapData"></open-street-map>
      <vs-row v-if="showInputs">
        <!-- Content-->
        <vs-input
          v-model="newAddress.province"
          :label="$t('users.addresses.province')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-province"
          :disabled="(mapData.opStatus === 'loaded' && mapData.province) || mapData.opStatus === 'clear'"
          :placeholder="mapData.opStatus === 'loaded' ? '' : $t('messages.autofill')"
        />
        <vs-input
          v-model="newAddress.district"
          :label="$t('users.addresses.district')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-district"
          :disabled="(mapData.opStatus === 'loaded' && mapData.district) || mapData.opStatus === 'clear'"
          :placeholder="mapData.opStatus === 'loaded' ? '' : $t('messages.autofill')"
        />
        <vs-input
          v-model="newAddress.county"
          :label="$t('users.addresses.county')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-county"
          :disabled="(mapData.opStatus === 'loaded' && mapData.county) || mapData.opStatus === 'clear'"
          :placeholder="mapData.opStatus === 'loaded' ? '' : $t('messages.autofill')"
        />
        <vs-input
          v-model="newAddress.city"
          :label="$t('users.addresses.city')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-city"
          :disabled="(mapData.opStatus === 'loaded' && mapData.city) || mapData.opStatus === 'clear'"
          :placeholder="mapData.opStatus === 'loaded' ? '' : $t('messages.autofill')"
        />
        <vs-input
          v-model="newAddress.borough"
          :label="$t('users.addresses.borough')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-borough"
          :disabled="(mapData.opStatus === 'loaded' && mapData.borough) || mapData.opStatus === 'clear'"
          :placeholder="mapData.opStatus === 'loaded' ? '' : $t('messages.autofill')"
        />
        <vs-input
          v-model="newAddress.village"
          :label="$t('users.addresses.village')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-village"
        />
        <vs-input
          v-model="newAddress.street"
          :label="$t('users.addresses.street')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-street"
        />
        <vs-input
          v-model="newAddress.line"
          :label="$t('users.addresses.line')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-line"
        />
        <vs-input
          v-model="newAddress.address"
          :label="$t('users.addresses.address')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-address"
        />
        <vs-input
          v-model="newAddress.postal"
          :label="$t('users.addresses.postal')"
          class="mt-5 w-full md:w-1/4 pr-3"
          name="new-postal"
        />
      </vs-row>
      <template v-else-if="mapData.province">
        <address-string :address="newAddress" />
        <vs-checkbox v-model="showInputs" @click="collapseClasses = ''" class="mt-2">{{
          $t('messages.complete_address')
        }}</vs-checkbox>
      </template>
      <div class="mt-8 pr-3">
        <vs-button
          :disabled="!mapData.province"
          class="w-full"
          color="success"
          type="border"
          @click="addNewAddress"
        >
          {{ $t('forms.save') }}
        </vs-button>
      </div>
    </template>
  </vx-card>
</template>

<script>
import OpenStreetMap from '@/views/components/maps/OpenStreetMap'
import AddressString from '@/views/components/maps/AddressString'

export default {
  name: 'SelectAddress',
  components: { AddressString, OpenStreetMap },
  data() {
    return {
      mapData: {},
      selectedAddressIndex: null,
      newAddress: {
        province: null,
        district: null,
        county: null,
        city: null,
        borough: null,
        village: null,
        postal: null,
        street: null,
        line: null,
        address: null
      },
      showInputs: false,
      clearMapMarker: false,
      showAddAddress: false
    }
  },
  watch: {
    selectedAddressIndex(val) {
      this.$emit('input', val)
    },
    mapData(value) {
      this.newAddress.location = value.location
      this.newAddress.province = value.province
      this.newAddress.district = value.district ? value.district : ''
      this.newAddress.county = value.county
      this.newAddress.city = value.city ? value.city : ''
      this.newAddress.borough = value.borough ? value.borough : ''
    }
  },
  methods: {
    addNewAddress() {
      const addresses = [...this.$store.state.AppActiveUser.addresses, this.newAddress]
      this.$store
        .dispatch('auth/editProfile', { addresses })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$store.commit('UPDATE_USER_INFO', {
            addresses: res.data.addresses
          })
          this.selectedAddressIndex = this.$store.state.AppActiveUser.addresses.length - 1
          this.mapData = {}
          this.newAddress = {}
          this.clearMapMarker = true
          this.$vs.notify({
            color: 'success',
            title: this.$t('forms.successfully_added')
          })
        })
    }
  }
}
</script>
